import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const setShowPrescribeStateError: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (value: boolean) => void
> = (set) => (value) =>
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionSubmitState.showPrescribeStateError = value;
    },
    false,
    'prescriptionSubmit/setShowPrescribeStateError',
  );
